import {ApiClient, type User} from '@hconnect/apiclient'

export const getLoginState = () => ApiClient.loginFlow.getLoginState()

export const startLogoutProcess = () => ApiClient.loginFlow.startLogoutProcess()

export const getUser = (userId: string) => {
  const userUrl = `/users/${userId}`
  return ApiClient.axiosInstance.get<User>(userUrl)
}
